// apps/web/src/features/agent/artifacts/TextArtifactCard.tsx (#1877)
//
// Renders a `text` artifact: an optional title and the body.
//
// INVARIANT (XSS): `body` is model-supplied and renders ONLY as a JSX text
// node. No `dangerouslySetInnerHTML`, no markdown/HTML parsing — a body
// containing `<script>` or `<img onerror=…>` appears as literal text.
import type { Artifact } from '@magimp/shared';

type TextArtifact = Extract<Artifact, { kind: 'text' }>;

export function TextArtifactCard({ artifact }: { artifact: TextArtifact }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--s-2)' }}>
      {artifact.title !== undefined ? (
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg-1)' }}>
          {artifact.title}
        </span>
      ) : null}
      <div style={{ fontSize: 13, color: 'var(--fg-1)', whiteSpace: 'pre-wrap' }}>
        {artifact.body}
      </div>
    </div>
  );
}
